import { motion } from 'framer-motion'
import UMark, { U_PATH } from './UMark'

const EASE = [0.16, 1, 0.3, 1]

function MLine({ children, delay = 0, className = '' }) {
  return (
    <motion.span
      className={`mask-line ${className}`}
      initial="hidden"
      whileInView="show"
      viewport={{ once: true, amount: 0.2 }}
    >
      <motion.span
        variants={{ hidden: { y: '112%' }, show: { y: '0%' } }}
        transition={{ duration: 1.1, ease: EASE, delay }}
      >
        {children}
      </motion.span>
    </motion.span>
  )
}

export default function Moment() {
  return (
    <section className="relative overflow-hidden bg-ink px-6 py-28 text-paper md:px-10 md:py-44" data-testid="moment-section">
      {/* ghost u-loop, slowly drawn */}
      <UMark
        animated
        strokeWidth={1.4}
        className="pointer-events-none absolute -right-16 -top-20 h-[130%] w-auto text-wave opacity-[0.08] md:right-10"
      />

      <div className="relative mx-auto flex max-w-5xl flex-col items-center text-center">
        <MLine delay={0}>
          <span className="eyebrow !text-[rgba(250,247,242,0.55)]">A thought we keep</span>
        </MLine>

        <h2 className="display-hero mt-10" data-testid="moment-headline">
          <MLine delay={0.1}>You don't need another</MLine>
          <MLine delay={0.22}>
            <span className="relative inline-flex items-baseline justify-center">
              <span className="text-brandblue">“perfect”</span>
              <motion.svg
                viewBox="0 0 300 24"
                className="absolute left-0 top-1/2 w-full -translate-y-1/2"
                initial={{ pathLength: 0 }}
                whileInView={{ pathLength: 1 }}
                viewport={{ once: true, amount: 0.6 }}
                transition={{ duration: 1.2, ease: EASE, delay: 0.9 }}
                aria-hidden="true"
              >
                <motion.path
                  d="M6 14 C 80 8, 210 8, 294 12"
                  fill="none"
                  stroke="#FF6B35"
                  strokeWidth="7"
                  strokeLinecap="round"
                  initial={{ pathLength: 0 }}
                  whileInView={{ pathLength: 1 }}
                  viewport={{ once: true, amount: 0.6 }}
                  transition={{ duration: 1.2, ease: EASE, delay: 0.9 }}
                />
              </motion.svg>
            </span>{' '}
            routine.
          </MLine>
        </h2>

        <motion.svg
          viewBox="0 0 24 24"
          className="floaty mt-12 h-8 w-8 text-[#FF6B35]"
          fill="none"
          stroke="currentColor"
          strokeWidth="1.8"
          initial={{ opacity: 0, scale: 0.6 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: EASE, delay: 0.4 }}
          aria-hidden="true"
          data-testid="moment-heart"
        >
          <path d="M12 20.5 C 7 16.5, 3.5 13.4, 3.5 9.6 C 3.5 7, 5.6 5, 8.1 5 C 9.8 5, 11.2 5.9, 12 7.3 C 12.8 5.9, 14.2 5, 15.9 5 C 18.4 5, 20.5 7, 20.5 9.6 C 20.5 13.4, 17 16.5, 12 20.5 Z" />
        </motion.svg>

        <MLine delay={0.45} className="mt-8">
          <p className="script-accent text-wave" data-testid="moment-subline">
            You just need something simple enough to stick to.
          </p>
        </MLine>

        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 1.4, ease: EASE, delay: 0.7 }}
          className="mt-16 flex items-center gap-3 text-[rgba(250,247,242,0.5)]"
          data-testid="moment-mark"
        >
          <svg viewBox="0 0 72 76" className="h-7 w-7" fill="none" aria-hidden="true">
            <path d={U_PATH} stroke="currentColor" strokeWidth="5" strokeLinecap="round" />
          </svg>
          <span className="eyebrow !text-[rgba(250,247,242,0.5)]">No More Bluff</span>
        </motion.div>
      </div>
    </section>
  )
}
